import { useEffect, useRef, useState } from "react";
import {
  MdControlPoint,
  MdDeleteOutline,
} from "react-icons/md";
import { apiPostPut } from "../../api/api_methods";
import { useStores } from "../../store";
import { AiOutlineClose } from "react-icons/ai";
import Loader from "../reusble_components/loader";
export default function Experiences() {
  const [jobType, setJobType] = useState("Job");
  const { UserStore } = useStores();
  const [city, setCity] = useState([]);
  const [cityName, setCityName] = useState("");
  const { PopupStore } = useStores();
  const [experiences, setExperiences] = useState([
    {
      company: "",
      designation: "",
      joiningDate: "",
      completionDate: "",
    },
  ]);
  const [showNotification, setShowNotification] = useState(false);
  const skillInputRef = useRef();
  const cityInputRef = useRef();
  const [salary, setSalary] = useState();
  const [showCity, setShowcity] = useState(false);
  const [PresentCompany, setPresentCompany] = useState("");
  const [PresentDesignation, setPresentDesignation] = useState("");
  const [PresentCTC, setPresentCTC] = useState("");
  const [PresentLoc, setPresentLoc] = useState("");
  const [PresentStipend, setPresentStipend] = useState("");
  const [popup, setPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [load, setLoad] = useState(false);
  const [defaultCities, setDefaultCities] = useState([
    "Visakhapatnam",
    "Hyderabad",
    "Bangalore",
    "Chennai",
    "Pune",
    "Mumbai",
    "Delhi",
  ]);

  const formatSalary = (salary) => {
    if (salary >= 10000000) return `${(salary / 10000000).toFixed(1)} Cr`;
    if (salary >= 100000) return `${(salary / 100000).toFixed(1)} L`;
    if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`;
    return salary;
  };

  useEffect(() => {
    formatSalary(salary);
  }, [salary]);

  useEffect(() => {
    UserStore.getUserDetails();
    const userDetails = UserStore.userDetails;
    if (userDetails?.previousCompanies) {
      setExperiences(userDetails.previousCompanies);
    }
    if (UserStore?.userDetails?.cityPreference) {
      setCity(UserStore?.userDetails?.cityPreference);
    }
    if (UserStore?.userDetails?.designation) {
      setPresentDesignation(UserStore?.userDetails?.designation);
    }
    if (UserStore?.userDetails?.currentSalary) {
      setPresentCTC(UserStore?.userDetails?.currentSalary);
    }
    if (UserStore?.userDetails?.company) {
      setPresentCompany(UserStore?.userDetails?.company);
    }
    if (userDetails?.previousCompanies?.length === 0) {
      setExperiences([
        {
          company: "",
          designation: "",
          joiningDate: "",
          completionDate: "",
        },
      ]);
    }
    if (userDetails?.lookingFor) {
      setJobType(userDetails.lookingFor);
    }
    if (userDetails?.openForFreeInternship) {
      setIsChecked(userDetails.openForFreeInternship);
    }
    if (userDetails?.workPreference) {
      setWorkTypes(userDetails.workPreference);
    }
    if (userDetails?.expectedSalary) {
      setSalary(userDetails.expectedSalary);
    }
  }, []);
  const addSkills = () => {
    setShowcity(true);
    setCity([...city, cityName]);

    // setSkills("");
  };
  const removeCity = (cityToRemove) => {
    setCity((prevCity) => prevCity.filter((city) => city !== cityToRemove));
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };
  const [workTypes, setWorkTypes] = useState([]);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    // If checked, add the value to the array, otherwise remove it
    if (checked) {
      setWorkTypes([...workTypes, value]);
    } else {
      setWorkTypes(workTypes.filter((type) => type !== value));
    }
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newExperiences = [...experiences];
    newExperiences[index][name] = value;
    setExperiences(newExperiences);
  };

  const handleAddExperience = () => {
    setExperiences([
      ...experiences,
      {
        company: "",
        designation: "",
        joiningDate: "",
        completionDate: "",
        description: "",
        currentlyWorking: false,
      },
    ]);
  };

  const handleDeleteExperience = (index) => {
    const newExperiences = [...experiences];
    newExperiences.splice(index, 1);
    setExperiences(newExperiences);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setShowNotification(false);
    setLoad(true);
    const userDetailslocal = JSON.parse(localStorage.getItem("user"));

    const body = {
      previousCompanies: experiences,
      lookingFor: jobType,
      expectedSalary: event.target.salary.value,
      openForFreeInternship: isChecked,
      workPreference: workTypes,
      cityPreference: city,
      company: PresentCompany,
      designation: PresentDesignation,
      currentSalary: PresentCTC,
    };

    const response = await apiPostPut(
      body,
      `/user/user-with-id/${userDetailslocal?._id}`,
      "PUT"
    );
    setLoad(false);
    if (response.status === 200) {
      console.log("output", response?.body?.data);
      setShowNotification(true);
      // const mergedData = { ...this.userDetails, ...response?.body?.data };
      // localStorage.setItem("user", JSON.stringify(mergedData));
      return UserStore.setUserDetails(response?.body?.data);
    } else {
      return alert("something went wrong");
    }
  };

  return (
    <div className="container border-t min-h-[65vh] mb-32 md:mb-0 tc7:w-[100%]">
      <Loader loader={load} />

      <div className="flex justify-between items-center ml-6 font-semibold text-lg mt-2">
        <span className=" md:hidden lg:hidden ml-2">Profile Info</span>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="mx-4 ml-4  md:mt-10 lg:mt-10 mt-2 tc6:w-[93vw] tc6:mx-5">
          <p className="px-4 pt-4 font-semibold">Experience</p>
          {experiences.map((experience, index) => (
            <div className="relative" key={index}>
              <div className="md:grid md:grid-cols-3 md:gap-4 gap-4 p-6 md:px-11 md:pl-6 lg:pl-6 lg:px-11 px-0 hover:relative">
                <div className="flex justify-end -mb-8 mr-7 mt-6 absolute top-0 right-0 opacity-50 text-lg hover:opacity-100">
                  <button
                    type="button"
                    className=""
                    onClick={() => handleDeleteExperience(index)}
                  >
                    <MdDeleteOutline />
                  </button>
                </div>
                <div className="mb-2 md:mb-0 flex flex-col lg:pb-4 lg:p-3">
                  <label
                    htmlFor={`designation${index}`}
                    className="form-label text-[#626161]"
                  >
                    Job Title
                  </label>
                  <input
                    type="text"
                    className="form-control border border-[#B6B6B6F5] p-3 mt-1 h-10 focus:outline-0 focus:border-primary rounded lg:h-16"
                    id={`designation${index}`}
                    name="designation"
                    placeholder="job title"
                    value={experience?.designation}
                    onChange={(e) => handleInputChange(index, e)}
                    required
                  />
                </div>
                <div className="flex flex-col">
                  <label
                    htmlFor={`companyName${index}`}
                    className="form-label truncate text-[#626161]"
                  >
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="form-control border focus:outline-0 focus:border-primary border-[#B6B6B6F5] p-3 mt-1 h-10 rounded lg:h-16"
                    id={`companyName${index}`}
                    name="company"
                    placeholder="Company Name"
                    value={experience?.company}
                    onChange={(e) => handleInputChange(index, e)}
                    required
                  />
                </div>
                <div className="mb-2 md:mb-0 flex flex-col lg:pb-4 lg:p-3">
                  <label
                    htmlFor={`location${index}`}
                    className="form-label text-[#626161]"
                  >
                    Location
                  </label>
                  <input
                    type="text"
                    className="form-control border border-[#B6B6B6F5] p-3 mt-1 h-10 focus:outline-0 focus:border-primary rounded lg:h-16"
                    id={`Location${index}`}
                    name="location"
                    placeholder="Location"
                    value={experience?.location}
                    onChange={(e) => handleInputChange(index, e)}
                    required
                  />
                </div>
                <div className="flex flex-col">
                  <label
                    htmlFor={`working${index}`}
                    className="form-label text-[#626161]"
                  >
                    Currently Working
                  </label>
                  <select
                    className="form-control border border-[#B6B6B6F5] px-3 mt-1 focus:outline-0 focus:border-primary h-10 rounded lg:h-16"
                    id={`working${index}`}
                    name="currentlyWorking"
                    value={experience?.currentlyWorking ?? "no"}
                    disabled={experiences.some(
                      (exp, i) => exp.currentlyWorking && i !== index
                    )}
                    onChange={(e) => handleInputChange(index, e)}
                    required
                  >
                    <option value={true}>Yes</option>
                    <option value={false}>No</option>
                  </select>
                </div>

                <div className="flex flex-col">
                  <label
                    htmlFor={`JoiningDate${index}`}
                    className="form-label text-[#626161]"
                  >
                    Date of Joining
                  </label>
                  <input
                    type="date"
                    className="form-control border border-[#B6B6B6F5] p-3 mt-1 focus:outline-0 focus:border-primary h-10 rounded lg:h-16"
                    id={`JoiningDate${index}`}
                    name="joiningDate"
                    placeholder="joining date"
                    value={experience?.joiningDate}
                    onChange={(e) => handleInputChange(index, e)}
                    required
                  />
                </div>
                {!experience?.currentlyWorking && (
                  <div
                    className={`flex flex-col ${
                      experience?.currentlyWorking && "hidden"
                    }`}
                  >
                    <label
                      htmlFor={`EndDate${index}`}
                      className="form-label text-[#626161]"
                    >
                      End Date
                    </label>
                    <input
                      type="date"
                      className="form-control border border-[#B6B6B6F5] p-3 mt-1 focus:outline-0 focus:border-primary h-10 rounded lg:h-16"
                      id={`EndDate${index}`}
                      name="completionDate"
                      placeholder="End Date"
                      value={experience?.completionDate}
                      onChange={(e) => handleInputChange(index, e)}
                      required
                    />
                  </div>
                )}
                <div className="flex flex-col col-span-3">
                  <label
                    htmlFor={`description${index}`}
                    className="form-label text-[#626161]"
                  >
                    Description
                  </label>
                  <textarea
                    type="text"
                    className="form-control border border-[#B6B6B6F5] p-3 mt-1 focus:outline-0 focus:border-primary h-20 rounded lg:h-16"
                    id={`description${index}`}
                    name="description"
                    placeholder="Description"
                    value={experience?.description}
                    onChange={(e) => handleInputChange(index, e)}
                    required
                  />
                </div>
              </div>
            </div>
          ))}
          <div className="flex">
            <button
              type="button"
              className="flex items-center justify-center ml-8 pr-[2%] mt-2 text-primary"
              onClick={handleAddExperience}
            >
              <MdControlPoint /> Add Experience
            </button>
          </div>
          <div className="h-10"></div>
          {showNotification && (
            <div className="flex items-center text-primary px-4 rounded-md mb-10">
              <span>Your details are updated Successfully!</span>
            </div>
          )}
          <div
            className={`${
              true
                ? "flex justify-start px-10 pb-5 -my-3"
                : "fixed bottom-5 right-12 p-5"
            }`}
          >
            <button
              type="submit"
              className="bg-[#000000] text-white h-10 w-40 rounded-xl lg:w-fit lg:h-fit -mx-7 md:mx-0 lg:mx-0"
            >
              <p className="lg:py-4 lg:px-24">Update</p>
            </button>
          </div>
        </div>
      </form>
      {popup && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center gap-8 bg-gray-500 bg-opacity-20 z-50">
          <div className="bg-white p-8 pt-10 rounded-xl relative flex items-center gap-4">
            <AiOutlineClose
              onClick={() => {
                setPopup(false);
                setPopupText("");
              }}
              className="absolute right-2 top-2 cursor-pointer"
            />
            <input
              type="text"
              placeholder={`Enter ${popupText}`}
              className="p-2 focus:outline-none rounded-lg text-2xl bg-gray-300"
              {...(popupText === "skill"
                ? { ref: skillInputRef }
                : { ref: cityInputRef })}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  if (popupText === "skill") {
                    const newSkill = skillInputRef.current.value;
                    addSkills(newSkill);
                    setPopup(false);
                  } else if (popupText === "city") {
                    const newCity = cityInputRef.current.value;
                    if (city.includes(newCity)) {
                      alert("City already exists");
                    }
                    if (newCity === "") {
                      alert("City cannot be empty");
                    }
                    if (!city.includes(newCity) && newCity !== "") {
                      setCity([...city, newCity]);
                    }
                    setPopup(false);
                  }
                  setPopup(false);
                  setPopupText("");
                }
              }}
            />
            <button
              className="bg-primary p-3 rounded-md text-white"
              onClick={() => {
                if (popupText === "skill") {
                  const newSkill = skillInputRef.current.value;
                  addSkills(newSkill);
                  setPopup(false);
                } else if (popupText === "city") {
                  const newCity = cityInputRef.current.value;
                  if (city.includes(newCity)) {
                    alert("City already exists");
                  }
                  if (newCity === "") {
                    alert("City cannot be empty");
                  }
                  if (!city.includes(newCity) && newCity !== "") {
                    setCity([...city, newCity]);
                  }
                  setPopup(false);
                }
                setPopup(false);
                setPopupText("");
              }}
            >
              ADD
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
